import * as yup from 'yup';

export const schemaTerminologyCreate = yup.object().shape({
  description: yup.string().required('Descrição obrigatória'),
});

export const schemaTerminologyEdit = yup.object().shape({
  description: yup.string().required('Descrição obrigatória'),
  status: yup.boolean().required('Status obrigatório'),
});
